import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  ShippingTypeImportAction,
  ShippingTypeTableListAction,
  addShippingTypeAction,
  deleteShippingTypeAction,
  updateShippingTypeAction,
} from "../../../../redux/actions/settings-action";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import successToast from "../../../helper-components/success-toast";
import errorToast from "../../../helper-components/error-toast";
import AddButton from "../../../buttons/button";
import search from "../../../../assets/icons/searchIcon.svg";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import { downloadAllTemplates } from "../../../helper-components/helper-function";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import DownloadIcon from "../../../../assets/icons/download-icon";
import excelImg from "../../../../assets/icons/excel.png";
import { Search } from "lucide-react";

const ShippingSetup = () => {
  const tableHeading = [
    "Shipping Type Name",
    "Carrier",
    "Field1",
    "Field2",
    "Field3",
    "Active",
    "Actions",
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [initialData, setShippingListData] = useState([]);
  const [selectedDOtIndex, setSelectedDotIndex] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [mainloading, setmainLoading] = useState(false);

  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };

  useEffect(() => {
    dispatch(ShippingTypeTableListAction({}, onFetchSuccess, onFetchError));
    setmainLoading(true);
  }, []);

  useEffect(() => {
    dispatch(
      ShippingTypeTableListAction({ searchValue }, onFetchSuccess, onFetchError)
    );
    setmainLoading(true);
  }, [searchValue, reload]);

  const reloadData = () => {
    dispatch(ShippingTypeTableListAction({}, onFetchSuccess, onFetchError));
    // setmainLoading(true);
  };

  const onFetchSuccess = (data) => {
    setShippingListData(data?.data?.shippingTypeList);
    setmainLoading(false);
  };

  const onFetchError = (data) => {
    setmainLoading(false);
    setShippingListData([]);
    errorToast(data?.message);
  };

  const initialValues = {
    data: initialData,
    newLine: {
      name: "",
      carrier: "",
      field_1: "",
      field_2: "",
      field_3: "",
      status: false,
    },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;

    // Collect changed array data
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        changedObjects.push(values.data[index]);
      }
    });

    // Collect new line data if it is altered
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }

    // Validate required fields for new line
    if (newLineObject !== null) {
      if (
        !newLineObject.name ||
        !newLineObject.carrier ||
        !newLineObject.field_1 ||
        !newLineObject.field_2 ||
        !newLineObject.field_3
      ) {
        errorToast(
          "Shipping Type, Carrier, Field1, Field2, Field3 are required in new line"
        );
        setSubmitting(false);
        return;
      }
      dispatch(
        addShippingTypeAction(newLineObject, onCreateSuccess, onCreateError)
      );
    }

    // Validate required fields for changed objects
    if (changedObjects.length > 0) {
      for (const obj of changedObjects) {
        if (
          !obj.name ||
          !obj.carrier ||
          !obj.field_1 ||
          !obj.field_2 ||
          !obj.field_3
        ) {
          errorToast(
            "Shipping Type,Carrier, Field1, Field2, Field3 are required in existing record"
          );
          setSubmitting(false);
          return;
        }
      }
      dispatch(
        updateShippingTypeAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }

    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onUpdateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onClickDelete = (id) => {
    dispatch(deleteShippingTypeAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    reloadData();
    successToast(data?.message);
    selectedDOtIndex(null);
  };

  const onError = (data) => {
    errorToast(data?.message);
    selectedDOtIndex(null);
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDotIndex(null);
    }
  };

  const TemplateArray = [
    {
      documentType: "Shipping Setup",
      expectedHeaders: [
        "name",
        "carrier",
        "field_1",
        "field_2",
        "field_3",
        "status",
      ],
    },
  ];

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const { handleFileUpload, loading } = useCsvUpload(
    ShippingTypeImportAction,
    TemplateArray?.[0]?.expectedHeaders
  );
  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="shipping-setup"
      // permissionFn={permissionFn}
    >
      <div className="mx-6">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue, dirty, handleSubmit }) => (
            <Form className="pt-1">
              <div
                className="flex flex-col gap-3"
                style={{ height: "85vh" }}
                onClick={handleClickOutside}
              >
                {/* <div className="flex justify-between my-3">
                  <div className="pb-4 flex items-center gap-2 text-sm">
                    <button
                      className="flex items-center gap-2"
                      onClick={() => {
                        navigate("/settings");
                      }}
                    >
                      <ChevronLeftIcon className="h-5 w-5 inline-block" />
                      Settings /
                    </button>
                    <span className="cursor-pointer">
                      {" " + "Shipping Setup"}
                    </span>
                  </div>
                  <div className="flex gap-3 pr-3">
                    <div
                      style={{ minWidth: "18rem", height: "2.5rem" }}
                      className={`input_border flex items-center rounded-md pb-1 w-10`}
                    >
                      <span className="px-2">
                        {" "}
                        <img width={"16px"} src={search} alt="search icon" />
                      </span>
                      <input
                        placeholder={`Search here`}
                        className=" table_search_input w-full rounded-md text-xs placeholder:text-xs"
                        type="text"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e?.target?.value);
                        }}
                      />
                      <span
                        className="text-sm mx-3 cursor-pointer text-primary"
                        onClick={() => setSearchValue("")}
                      >
                        Clear
                      </span>
                    </div>
                    <div>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={(e) =>
                          handleFileUpload(e, onSuccess, onError)
                        } // Pass onSuccess and onError functions
                        className="hidden"
                        id="csv-upload"
                      />
                      <label htmlFor="csv-upload">
                        <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                          <img
                            width={20}
                            height={30}
                            src={excelImg}
                            alt="excel-icon"
                          />
                          {loading ? (
                            <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                          ) : (
                            <span>Import</span>
                          )}
                        </div>
                      </label>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        downloadAllTemplates(TemplateArray);
                      }}
                      className="border-027A48 border-2 rounded-md px-2 py-2"
                    >
                      <DownloadIcon fill="var(--success-color)" />
                    </button>
                  </div>
                </div> */}

                <div className="flex justify-between items-center">
                  <div className=" flex items-center gap-2 text-sml ">
                    <button
                      className="flex items-center gap-2"
                      onClick={() => {
                        navigate("/settings");
                      }}
                    >
                      <ChevronLeftIcon className="h-5 w-5 inline-block " />
                      Data Setup Settings /
                    </button>
                    <span className="cursor-pointer">{" " + "Shipping"}</span>
                  </div>
                  <div className="flex items-center gap-3 pr-3">
                    <div
                      style={{ minWidth: "18rem", height: "2.5rem" }}
                      className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
                    >
                      <input
                        // ref={searchRef}
                        placeholder={`Search (/)`}
                        className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                        type="text"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e?.target?.value);
                        }}
                      />
                      <span className="px-2">
                        {" "}
                        {<Search size="16" color="#9CA3AF" />}
                      </span>
                    </div>
                    <div className=" flex flex-row gap-3">
                      <div>
                        <input
                          type="file"
                          accept=".csv"
                          onChange={(e) =>
                            handleFileUpload(e, onSuccess, onError)
                          } // Pass onSuccess and onError functions
                          className="hidden"
                          id="csv-upload"
                        />
                        <label htmlFor="csv-upload">
                          <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                            <img
                              width={20}
                              height={30}
                              src={excelImg}
                              alt="excel-icon"
                            />
                            {loading ? (
                              <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                            ) : (
                              <span>Import</span>
                            )}
                          </div>
                        </label>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          downloadAllTemplates(TemplateArray);
                        }}
                        className="border-027A48 border-2 rounded-md px-2 py-1"
                      >
                        <DownloadIcon fill="var(--success-color)" />
                      </button>
                    </div>
                  </div>
                </div>
                {mainloading ? (
                  <LoadingSpinner />
                ) : (
                  <div className="overflow-auto rounded-xl table-container border border-gray-200">
                    <table className=" w-full ">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                        <tr className="relative h-[50px]">
                          {tableHeading.map((heading, index) => (
                            <th
                              className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                              key={heading}
                            >
                              {heading?.toUpperCase()}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {values.data.map((item, index) => (
                          <tr key={index}>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary `}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].name`}
                                placeholder="Name"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "name",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-36"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary `}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].carrier`}
                                placeholder="Carrier"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "carrier",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary `}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].field_1`}
                                placeholder="Field 1"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "field_1",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary `}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].field_2`}
                                placeholder="Field 2"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "field_2",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary `}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].field_3`}
                                placeholder="Field 3"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "field_3",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                maxLength={20}
                                name={`data[${index}].status`}
                                disabled={disableArrayFields}
                                type={"checkbox"}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "status",
                                    e.target.checked,
                                    setFieldValue
                                  )
                                }
                                className="border-[1px] focus:outline-none h-[18px] w-[18px] rounded-[6px] px-1 py-2"
                              />
                            </td>
                            <td className="tab-cell  w-[5rem] text-sm fw_400 text-secondary p-8">
                              {/* <button
                                onClick={() => setSelectedDotIndex(index)}
                              >
                                <KibabMenu />
                              </button>
                              {selectedDOtIndex === index && (
                                <div
                                  ref={componentRef}
                                  style={{
                                    position: "absolute",
                                    right: "5rem",
                                    boxShadow:
                                      "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                  }}
                                  className="bg-white rounded w-38"
                                >
                                  <div className="w-full p-3">
                                    <button
                                      className="w-full flex align-middle gap-2 px-2 py-1"
                                      onClick={() => onClickDelete(item?.id)}
                                    >
                                      <div className="mt-1">
                                        <DeleteIcon />
                                      </div>
                                      <span className="text-sm">Delete</span>
                                    </button>
                                  </div>
                                </div>
                              )} */}
                              <button
                                className="w-full flex align-middle gap-2 px-2 py-1"
                                onClick={() => onClickDelete(item?.id)}
                              >
                                <div className="mt-1">
                                  <DeleteIcon />
                                </div>
                                {/* <span className="text-sm">Delete</span> */}
                              </button>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              name="newLine.name"
                            >
                              {({ field }) => (
                                <input
                                  {...field}
                                  maxLength={20}
                                  placeholder="Name"
                                  disabled={disableNewFields}
                                  className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-36"
                                  autoFocus={searchValue ? false : true}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                                    handleFieldChange(
                                      "newLine",
                                      "name",
                                      value,
                                      setFieldValue
                                    );
                                  }}
                                  onBlur={(e) => {
                                    if (!e.target.value) {
                                      errorToast("Name is required");
                                    }
                                  }}
                                />
                              )}
                            </Field>
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              maxLength={20}
                              name="newLine.carrier"
                              placeholder="Carrier"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "carrier",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-24"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              maxLength={20}
                              name="newLine.field_1"
                              placeholder="Field 1"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "field_1",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              maxLength={20}
                              name={`newLine.field_2`}
                              placeholder="Field 2"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "field_2",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              maxLength={20}
                              name={`newLine.field_3`}
                              placeholder="Field 3"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "field_3",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-24"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary `}
                          >
                            <Field
                              maxLength={20}
                              name={`newLine.status`}
                              disabled={disableNewFields}
                              type={"checkbox"}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "status",
                                  e.target.checked,
                                  setFieldValue
                                )
                              }
                              className="border-[1px] focus:outline-none h-[18px] w-[18px] rounded-[6px] px-1 py-2"
                            />
                          </td>
                          <td className="tab-cell  w-[5rem] text-sm fw_400 text-secondary p-8">
                            <button>
                              <KibabMenu />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
                <AddButton
                  onclkFn={handleSubmit}
                  prefixIcon={false}
                  text="Save"
                  type="submit"
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </InnerLayout>
  );
};

export default ShippingSetup;
